if (!customElements.get('shoe-lifts-proof-media')) {
  customElements.define('shoe-lifts-proof-media', class extends HTMLElement {
    connectedCallback() {
      // Wait for child markup when an already registered section is inserted.
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.events = new AbortController();
      const { signal } = this.events;
      const track = this.querySelector('.shoe-lifts-proof-media__track');
      const navigation = this.querySelector('.shoe-lifts-proof-media__navigation');
      const previous = navigation.querySelector('[data-direction="previous"]');
      const next = navigation.querySelector('[data-direction="next"]');
      const updateNavigation = () => {
        navigation.hidden = track.scrollWidth <= track.clientWidth + 1;
        if (!track.firstElementChild) return;
        const bounds = track.getBoundingClientRect();
        previous.disabled = track.firstElementChild.getBoundingClientRect().right <= bounds.right + 1;
        next.disabled = track.lastElementChild.getBoundingClientRect().left >= bounds.left - 1;
      };
      navigation.addEventListener('click', (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || button.disabled || !track.firstElementChild) return;
        const distance = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({
          left: button.dataset.direction === 'next' ? -distance : distance,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, { signal });
      track.addEventListener('scroll', updateNavigation, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(updateNavigation);
      this.resizeObserver.observe(track);
      updateNavigation();
      this.querySelectorAll('video').forEach((video) => {
        const button = video.parentElement.querySelector('.shoe-lifts-proof-media__play');
        video.controls = false;
        button.hidden = false;
        const updatePlayback = () => {
          const playing = !video.paused && !video.ended;
          button.setAttribute('aria-pressed', String(playing));
          button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        };
        button.addEventListener('click', () => {
          if (!video.paused) {
            video.pause();
            return;
          }
          video.play().catch(() => {
            // Preserve a native retry path if media playback fails.
            video.controls = true;
            button.hidden = true;
          });
        }, { signal });
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach((other) => { if (other !== video) other.pause(); });
          updatePlayback();
        }, { signal });
        ['pause', 'ended'].forEach((name) => video.addEventListener(name, updatePlayback, { signal }));
        updatePlayback();
      });
      // Reveal a selected block when navigating cards in the Theme Editor.
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.shoe-lifts-proof-media__card');
        if (card) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
      }, { signal });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}
